import React from 'react';

import HeaderATS from './HeaderAts';
import FooterAts from './FooterAts';
import { EnvelopeIcon, MapPinIcon, PhoneIcon } from '@heroicons/react/24/outline';
import ats from './data';
import ContactForm from './ContactForm';


const Contact = () => {
    const info = ats.info;
    
    return (
        <div>
            <HeaderATS />
            <div className="relative isolate bg-white">
            <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
                <div className="relative px-6 pb-20 pt-24 sm:pt-32 lg:static lg:px-8 lg:py-48">
                <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
                    <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
                    <svg
                        aria-hidden="true"
                        className="absolute inset-0 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                    >
                        <defs>
                        <pattern
                            x="100%"
                            y={-1}
                            id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                            width={200}
                            height={200}
                            patternUnits="userSpaceOnUse"
                        >
                            <path d="M130 200V.5M.5 .5H200" fill="none" />
                        </pattern>
                        </defs>
                        <rect fill="white" width="100%" height="100%" strokeWidth={0} />
                        <svg x="100%" y={-1} className="overflow-visible fill-gray-50">
                        <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                        </svg>
                        <rect fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)" width="100%" height="100%" strokeWidth={0} />
                    </svg>
                    </div>
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900">Contact us</h2>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                    Schedule in a test drive or send us a quick message:
                    </p>
                    <dl className="mt-10 space-y-4 text-base leading-7 text-gray-600">
                    <div className="flex gap-x-4">
                        <dt className="flex-none">
                        <span className="sr-only">Address</span>
                        <MapPinIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
                        </dt>
                        <dd>
                        {info.address1}
                        <br />
                        {info.address2}
                        </dd>
                    </div>
                    <div className="flex gap-x-4">
                        <dt className="flex-none">
                        <span className="sr-only">Telephone</span>
                        <PhoneIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
                        </dt>
                        <dd>
                        <a href={`tel:${info.tel}`} className="hover:text-gray-900">
                            +1 {info.tel}
                        </a>
                        </dd>
                    </div>
                    <div className="flex gap-x-4">
                        <dt className="flex-none">
                        <span className="sr-only">Email</span>
                        <EnvelopeIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
                        </dt>
                        <dd>
                        <a href={`mailto:${info.email}`} className="hover:text-gray-900">
                            {info.email}
                        </a>
                        </dd>
                    </div>
                    </dl>

                    <hr className='mt-8 border-gray-200' />

                    <div className="mt-8">
                    <h3 className="text-xl font-bold tracking-tight text-gray-900">Business Hours</h3>
                    <p className='mt-2 text-lg leading-8 text-gray-600 italic font-semibold'>Vehicle Sales</p>
                    <p className="mt-2 text-lg leading-8 text-gray-600">
                    <b className='font-bold'>Monday - Friday:</b> 9:00am - 7:00pm
                    <br />
                    {/*<span className='font-bold'>Friday:</span> 9:00am - 6:00pm
                    <br />*/}
                    <span className='font-bold'>Saturday-Sunday: Closed</span>
                    </p>
                    <div className="mt-8">
                    <h3 className="mt-2 text-lg leading-8 text-gray-600 italic font-semibold">Automotive Detailing</h3>
                    <p className='mt-2 text-lg leading-8 text-gray-600'><span className='font-bold'>Sundays:</span> 10:00am - 5:00pm (by appointment only).</p>
                    </div>
                    </div>
                </div>
                </div>
                
                <ContactForm />
                
            </div>
            </div>
            <FooterAts />
        </div>
    );
};

export default Contact;